"use client";

import { forwardRef, useState } from "react";
import { Eye, EyeOff } from "@/components/icons";
import { Input } from "@/components/ui/input";
import { useI18n } from "@/lib/i18n/I18nProvider";
import { cn } from "@/lib/utils";
import { loginFieldClasses } from "./styles";

type PasswordInputProps = Omit<React.ComponentProps<typeof Input>, "type"> & { hasError: boolean };

/**
 * Campo de contraseña del login con botón para mostrarla. El botón está en el orden de tabulación
 * (WCAG 2.2: autenticación accesible) y queda dentro del campo: 42 px con 4 px de margen, radio 12 − 4 = 8.
 */
export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(function PasswordInput(
  { hasError, className, disabled, ...props },
  ref
) {
  const { t } = useI18n();
  const [show, setShow] = useState(false);

  return (
    <div className="relative">
      <Input
        ref={ref}
        type={show ? "text" : "password"}
        disabled={disabled}
        className={cn(loginFieldClasses(hasError), "pr-12", className)}
        {...props}
      />
      <button
        type="button"
        onClick={() => setShow((v) => !v)}
        disabled={disabled}
        aria-label={show ? t("login.hidePassword") : t("login.showPassword")}
        className="absolute right-1 top-1 flex h-[42px] w-[42px] items-center justify-center rounded-[8px] text-muted-foreground transition-colors duration-200 hover:text-foreground focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-ring/30 disabled:opacity-50"
      >
        {show ? <EyeOff className="h-[18px] w-[18px]" /> : <Eye className="h-[18px] w-[18px]" />}
      </button>
    </div>
  );
});
